/**
 * Trunnion AI - Keyboard Shortcut Definitions
 * Centralized registry of all platform keyboard shortcuts.
 */

export interface ShortcutDef {
  id: string;
  keys: { key: string; meta?: boolean; ctrl?: boolean; shift?: boolean; alt?: boolean };
  label: string;
  description: string;
  scope: 'global' | 'designer' | 'chat';
}

export const SHORTCUTS: ShortcutDef[] = [
  {
    id: 'command-palette',
    keys: { key: 'k', meta: true },
    label: 'Command Palette',
    description: 'Open the command palette for quick navigation and actions',
    scope: 'global',
  },
  {
    id: 'toggle-sidebar',
    keys: { key: '/', meta: true },
    label: 'Toggle Sidebar',
    description: 'Collapse or expand the sidebar navigation',
    scope: 'global',
  },
  {
    id: 'new-workflow',
    keys: { key: 'n', meta: true, shift: true },
    label: 'New Workflow',
    description: 'Create a new workflow in the designer',
    scope: 'global',
  },
  {
    id: 'new-agent',
    keys: { key: 'a', meta: true, shift: true },
    label: 'New Agent',
    description: 'Create a new agent',
    scope: 'global',
  },
  {
    id: 'show-shortcuts',
    keys: { key: '?' },
    label: 'Keyboard Shortcuts',
    description: 'Show this keyboard shortcuts cheatsheet',
    scope: 'global',
  },
  {
    id: 'undo',
    keys: { key: 'z', meta: true },
    label: 'Undo',
    description: 'Undo the last action in the workflow designer',
    scope: 'designer',
  },
  {
    id: 'redo',
    keys: { key: 'z', meta: true, shift: true },
    label: 'Redo',
    description: 'Redo the last undone action in the workflow designer',
    scope: 'designer',
  },
  {
    id: 'save-workflow',
    keys: { key: 's', meta: true },
    label: 'Save Workflow',
    description: 'Save the current workflow',
    scope: 'designer',
  },
];
